/**
 * Initializes an Alpine.js data object for an Instagram-style carousel.
 * Key features include:
 * 1. Swiper Integration: Utilizes Swiper for a customizable, responsive carousel.
 * 2. Dynamic Layout: Adjusts carousel settings based on breakpoints for optimal display.
 * 3. Interactive Navigation: Incorporates next and previous slide navigation.
 */

function instagramCarousel() {
  return {
    swiper: null,

    init() {
      this.cacheNodes();
      this.buildSwiper();
    },

    cacheNodes() {
      this.swiperContainer = document.querySelector('.instagram-carousel__slide-container');
    },

    buildSwiper() {
      if (this.swiper || !this.swiperContainer) {
        return;
      }
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: this.swiperContainer.querySelector('.swiper-button-next-insta'),
          prevEl: this.swiperContainer.querySelector('.swiper-button-prev-insta'),
        },
        breakpoints: {
          1023: {
            centeredSlides: false,
          },
        },
        on: {
          init: () => {
            setTimeout(() => {}, 100);
          },
        },
      });
    },
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('instagramCarousel', instagramCarousel);
});
